import { IconApi, IconChecklist } from '@tabler/icons-react'

import { asContainer } from 'lib/container'

import { CenterContent } from 'components/Layout'
import { NavigationCard } from 'components/NavigationCard'

import { Background } from './Background'
import { Container } from './Container'
import { Content } from './Content'
import { Title } from './Title'

type State = {}

export const container = asContainer<State>()({
	path: '/',
	authentication: { type: 'public' },
	Running: () => (
		<CenterContent>
			<Container>
				<Content>
					<Title>
						Launch great product features
						<br />
						by leveraging Subaio white label functionality
					</Title>
					<NavigationCard name='Docs' title='Documentation and guides' icon={<IconChecklist />}>
						Guides on how to send transactions, use our SDKs, interact with our Partner API and more.
					</NavigationCard>
					<NavigationCard name='Apis/PartnerApi/v2' title='Partner API reference' icon={<IconApi />}>
						Documentation of the Subaio Partner API used to perform user onboarding, user logins and fetch data.
					</NavigationCard>
				</Content>
				<Background />
			</Container>
		</CenterContent>
	),
})
